import { Injectable } from "@angular/core";
import * as FileSaver from "file-saver";
import { Workbook } from "exceljs";
// declare var ExcelJS: any;
// declare var saveAs: any;

const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

@Injectable({
    providedIn: "root",
})
export class ExcelService
{

    constructor() { }

    exportPayment(json: any[], excelFileName: string)
    {
        const headersArray = ["Date", "Reference No.", "Status", "Check Number", "Amount"];
        this.exportAsExcelFile(json, excelFileName, headersArray, (worksheet1) =>
        {
            worksheet1.getColumn(5).numFmt = "#,##0.00";
        });
    }

    exportTransaction(json: any[], excelFileName: string)
    {
        const headersArray = ["Date", "Reference No.", "Description", "Status", "Location", "Type", "Qty", "Price", "Amount"];

        this.exportAsExcelFile(json, excelFileName, headersArray, (worksheet1) =>
        {
            worksheet1.getColumn(7).numFmt = "#,##0.00";
            worksheet1.getColumn(8).numFmt = "#,##0.00000";
            worksheet1.getColumn(9).numFmt = "#,##0.00";
        });
    }

    public exportAsExcelFile(json: any[], excelFileName: string, headersArray: any[], callback: (myFunction: any) => void): void
    {

        const header = headersArray;
        const data = json;
        const workbook1 = new Workbook();
        const worksheet1 = workbook1.addWorksheet(excelFileName);

        worksheet1.columns = header;

        // style header row
        const headerRow = worksheet1.addRow(header);
        headerRow.eachCell((cell, num) =>
        {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "00dfeaed" },
                bgColor: { argb: "00dfeaed" },
            };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
        });

        // add data
        data.forEach(element => { worksheet1.addRow(element); });

        // align and set width, height to all columns
        worksheet1.properties.defaultRowHeight = 18;
        worksheet1.columns.forEach(column =>
        {
            column.alignment = { vertical: "middle", horizontal: "right" };
            column.width = 15;
        });

        if (callback)
        {
            callback(worksheet1);
        }

        // save
        workbook1.xlsx.writeBuffer().then((myData) =>
        {
            const blob = new Blob([myData], { type: EXCEL_TYPE });
            FileSaver.saveAs(blob, excelFileName + "_export_" + new Date().toLocaleDateString() + EXCEL_EXTENSION);
        });
    }
}
